import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AccountService } from '@core/services/account.service';

/**
 * Resolver function that fetches the current user's account details.
 * This resolver is executed before the route is activated, ensuring account
 * information is loaded and available to the component.
 *
 * @returns {Promise<void>} A promise that resolves when account details have been fetched
 */
export const accountDetailsResolver: ResolveFn<void> = async () => {
  await inject(AccountService).fetchMyAccountDetails(true);
}